'use client';
import styled, { css } from 'styled-components';

export const Card = styled.div`
  border-radius: ${({ $hasImage, $totalCardCount }) =>
    $hasImage || $totalCardCount <= 3 ? '24px' : '16px'};
  border: 1px solid
    ${({
      theme,
      checked,
      $borderColor,
      $checkedBorderColor,
      $unavailable,
      $disabled,
    }) =>
      $unavailable || $disabled
        ? 'transparent'
        : checked && $checkedBorderColor
        ? theme.colors.get($checkedBorderColor)
        : $borderColor
        ? theme.colors.get($borderColor)
        : theme.colors.border.light};
  display: inline-flex;
  flex-direction: column;
  user-select: none;
  overflow: hidden;
  position: relative;
  width: 365px;
  max-height: fit-content;
  min-height: ${({ $hasImage, $totalCardCount }) =>
    $hasImage || $totalCardCount <= 3 ? '85px' : '60px'};
  background: ${({
    theme,
    $unavailable,
    $disabled,
    checked,
    $checkedBackgroundColor,
  }) =>
    $unavailable
      ? theme.colors.background.disabled
      : $disabled
      ? theme.colors.background.lightest
      : checked
      ? theme.colors.get($checkedBackgroundColor)
      : theme.colors.background.base};
  opacity: ${({ $notSelectable }) => ($notSelectable ? 0.5 : 1)};
  color: ${({ theme }) => theme.colors.text.primary};
`;

export const CardContent = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  flex: 1;
  gap: 1px;
  padding: ${({ theme, $hasImage }) =>
    $hasImage ? theme.spacing(1, 2) : theme.spacing(3, 4)};
`;

export const StyledImage = styled.div`
  display: flex;
  align-items: center;
  border-radius: 16px;
  overflow: hidden;
  object-position: left;
  object-fit: cover;
  min-height: 100px;
  min-width: 100px;
  filter: ${props => props.unavailable && 'grayscale(100%) brightness(93%)'};
  padding: ${({ theme }) => theme.spacing(0, 2)};
`;

export const Info = styled.div`
  max-width: 251px;
  padding-left: ${({ theme, $hasImage }) =>
    $hasImage ? theme.spacing(2) : theme.spacing(0)};
  display: flex;
  flex-direction: ${props => props.$textDirection};
  ${props =>
    props.$textDirection === 'row'
      ? css`
          align-items: baseline;
          gap: ${props.theme.spacing(2)};
        `
      : ''};
`;

export const CardHeader = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing(4)};
`;

export const Name = styled.h5`
  ${({ theme }) => theme.typography.heading5}
  color: ${({ theme, $titleColor }) => theme.colors.get($titleColor)};
  text-transform: capitalize;
`;

export const Description = styled.p`
  ${({ theme }) => theme.typography.body}
  color: ${({ theme, $descriptionColor }) =>
    theme.colors.get($descriptionColor)};
  margin-top: ${({ theme, $hasImage }) =>
    $hasImage ? theme.spacing(1) : theme.spacing(0)};
  text-align: left;
  ${props =>
    props.$textDirection === 'column' && props.$hasImage && 'min-height: 52px'};
`;
